import { ShieldSwordOutlineIcon } from './ShieldSwordOutlineIcon';

/**
 * author: Michael Miday
 * id 3F8FADE9-864C-4B66-921A-A0DC30683E2A
 * name shield-sword-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-sword-outline.svg
 * tags
 * - Gaming / RPG 
 */
export const ModeratorOutlineIcon = ShieldSwordOutlineIcon;
export default ModeratorOutlineIcon